import { render, staticRenderFns } from "./superiorPopup.vue?vue&type=template&id=dea94842&scoped=true&"
import script from "./superiorPopup.vue?vue&type=script&lang=js&"
export * from "./superiorPopup.vue?vue&type=script&lang=js&"
import style0 from "./superiorPopup.vue?vue&type=style&index=0&id=dea94842&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea94842",
  null
  
)

export default component.exports